














import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({})
export default class AppTab extends Vue {
  @Prop({ type: Number, default: 0 }) value!: number;
  @Prop({ type: Array }) readonly items!: string[];
  tab = null;

  activeTab = 0;

  changeTab (index: number) {
    this.activeTab = index
    this.emitTab()
  }

  @Emit('change')
  emitTab () {
    return this.activeTab
  }

  @Watch('value', { immediate: true })
  changeValue (val: number) {
    this.activeTab = val
  }
}
